import React, { FC } from 'react';
import {
  Filter,
  TextInput,
  BooleanInput,
  SelectInput,
  FilterProps,
  NullableBooleanInput,
} from 'react-admin';
import Box from '@material-ui/core/Box';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';
import { SupervisorReferenceInput } from 'components/SupervisorReferenceInput';
import { DebouncedTextInput } from 'components/DebouncedTextInput';

export enum POFilterStatus {
  'Signed' = 'Signed',
  'UnSigned' = 'UnSigned',
}

type StatusChoice = {
  id: POFilterStatus;
  name: string;
};

const statusChoices: StatusChoice[] = [
  { id: POFilterStatus.Signed, name: 'Signed' },
  { id: POFilterStatus.UnSigned, name: 'Unsigned' },
];

export const JobSheetFilters: FC<FilterProps> = props => (
  <Box>
    <Filter {...props}>
      <SupervisorReferenceInput
        label="Supervisor"
        source="supervisorUserIds||$cont"
      />
      <DebouncedTextInput
        label="Lot"
        source="jobLot||$eq"
        resettable
        data-cy="masterSheetFilterLot"
      />
      <TextInput
        label="Block"
        source="jobBlock||$eq"
        resettable
        data-cy="masterSheetFilterBlock"
      />
      <TextInput label="PO ID" source="orderNumber" resettable />
      <LazyReferenceInput
        label="Builder"
        source="builderId"
        reference="builder"
        resettable
        data-cy="masterSheetFilterBuilder"
        allowEmpty={false}
        filterToQuery={name => (name ? { name } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceInput
        label="Model"
        source="modelId"
        reference="model"
        resettable
        data-cy="masterSheetFilterBuilder"
        allowEmpty={false}
        filterToQuery={name => (name ? { name } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceInput
        label="Subdivision"
        source="subdivisionId"
        reference="subdivision"
        resettable
        data-cy="masterSheetFilterSubdivision"
        alwaysOn
        allowEmpty={false}
        filterToQuery={name => (name ? { name } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceInput
        label="Current Supplier"
        source="supplierId"
        reference="supplier"
        resettable
        data-cy="masterSheetFilterSupplier"
        allowEmpty={false}
        filterToQuery={value => (value ? { name: value } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <BooleanInput alwaysOn source="voided||$eq" label="Voided" />
      <DebouncedTextInput
        label="Address"
        source="jobAddress1||$cont"
        resettable
        data-cy="address1Filter"
      />
      <SelectInput
        label="Status"
        source="poStatus||$eq"
        choices={statusChoices}
      />
      <NullableBooleanInput
        source="preRock||$eq"
        label="Pre-Rock"
        alwaysOn
        options={{
          SelectProps: { displayEmpty: true },
          InputLabelProps: { shrink: true },
        }}
        nullLabel="All"
        falseLabel="No"
        trueLabel="Yes"
        data-cy="masterSheetFilterActivesJob"
      />
    </Filter>
  </Box>
);
